import * as React from 'react';

import styled, { css } from 'styled-components';

import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';

type ChipType = 'success' | 'danger' | 'blue';

interface ChipProps {
  className?: string;
  children: React.ReactNode;
  small?: boolean;
  smaller?: boolean;
  smallFont?: boolean;
  hasActive?: boolean;
  chipType?: ChipType;
}

export const Chip: React.FC<ChipProps> = (props) => {
  return (
    <MotionOpacity>
      <ChipWrapper
        className={props.className}
        small={props.small}
        smaller={props.smaller}
        chipType={props.chipType}
        hasActive={props.hasActive}
      >
        <ChipText
          weight="700"
          chipType={props.chipType}
          hasActive={props.hasActive}
          smallFont={props.smallFont}
          type={props.smallFont ? 'smaller' : undefined}
        >
          {props.children}
        </ChipText>
      </ChipWrapper>
    </MotionOpacity>
  );
};

export default Chip;

const ChipWrapper = styled.div<{
  small?: boolean;
  smaller?: boolean;
  hasActive?: boolean;
  chipType?: ChipType;
}>`
  padding: ${({ small, smaller }) =>
    smaller ? '0 4px' : small ? '8px 10px' : '10px 18px'};
  position: relative;
  border-radius: 18px;
  background-color: ${({ hasActive }) =>
    hasActive
      ? css`
          ${({ theme }) => theme.colors.differentBackground}
        `
      : css`
          ${({ theme }) => theme.colors.primary}
        `};
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};
  z-index: 1;

  ${({ chipType }) =>
    chipType === 'success'
      ? css`
          background-color: ${({ theme }) => theme.colors.greenLight};
        `
      : null}

  ${({ chipType }) =>
    chipType === 'blue'
      ? css`
          background-color: ${({ theme }) => theme.colors.blueColor};
        `
      : null}
`;

const ChipText = styled(Typography)<{
  small?: boolean;
  smallFont?: boolean;
  hasActive?: boolean;
  chipType?: ChipType;
}>`
  z-index: 10;
  position: relative;
  line-height: 16px;

  color: ${({ hasActive }) =>
    hasActive
      ? css`
          ${({ theme }) => theme.colors.primary}
        `
      : css`
          ${({ theme }) => theme.colors.background}
        `};

  ${({ chipType }) =>
    chipType === 'success'
      ? css`
          color: ${({ theme }) => theme.colors.green};
        `
      : null}

  ${({ chipType }) =>
    chipType === 'blue'
      ? css`
          color: ${({ theme }) => theme.colors.white};
        `
      : null}
  ${({ smallFont }) =>
    smallFont
      ? css`
          line-height: ${({ theme }) => theme.typography.h3};
        `
      : null}
`;
